import React from "react";
import { Space, Typography } from "antd";
import { useInvoiceReview } from "../../context/InvoiceReviewContext";

const { Text } = Typography;

const ReconciliationStats = () => {
    const { invoices, reconciliationState } = useInvoiceReview();

    // 计算统计信息
    const statistics = React.useMemo(() => {
        if (!invoices || invoices.length === 0) {
            return { totalItems: 0, problemItems: 0, modifiedItems: 0 };
        }

        let totalItems = 0;
        let problemItems = 0;
        let modifiedItems = 0;
        const dirtyFields = reconciliationState?.dirtyFields || new Set();

        invoices.forEach((invoice, invoiceIdx) => {
            invoice.sections.forEach((section, sectionIdx) => {
                section.line_items.forEach((item, itemIdx) => {
                    totalItems++;
                    // 检查是否有问题（异常或未匹配）
                    const hasAnomalies = item.anomalies?.length > 0;
                    const hasNoFlight = item.matched_flight_id === null;
                    if (hasAnomalies || hasNoFlight) {
                        problemItems++;
                    }
                    // 检查是否被用户修改
                    const fieldPath = `invoices[${invoiceIdx}].sections[${sectionIdx}].line_items[${itemIdx}]`;
                    if (Array.from(dirtyFields).some((path) => path === fieldPath || path.startsWith(fieldPath + "."))) {
                        modifiedItems++;
                    }
                });
            });
        });

        return { totalItems, problemItems, modifiedItems };
    }, [invoices, reconciliationState]);

    return (
        <Space size="large" style={{ fontSize: "14px" }}>
            <Text type="secondary">
                账单: <Text strong>{invoices.length}</Text> 张
            </Text>
            {/* <Text type="secondary">
                问题:{" "}
                <Text strong style={{ color: statistics.problemItems > 0 ? "#cf1322" : "#3f8600" }}>
                    {statistics.problemItems}
                </Text>
                /{statistics.totalItems}
            </Text>
            <Text type="secondary">
                已修改:{" "}
                <Text strong style={{ color: "#1890ff" }}>
                    {statistics.modifiedItems}
                </Text>{" "}
                项
            </Text> */}
        </Space>
    );
};

export default ReconciliationStats;
